import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IAddressModel } from 'lib-core-shared';
@Component({
  selector: 'app-address-suggestion-options',
  templateUrl: './address-suggestion-options.component.html',
  styleUrls: ['./address-suggestion-options.component.scss']
})
export class AddressSuggestionOptionsComponent implements OnInit {
  @Output() public choiceEmitter = new EventEmitter<IAddressModel>();
  @Input() public suggestedAddress!: IAddressModel;
  @Input() public address: IAddressModel | undefined;
  constructor() { }

  ngOnInit(): void {
  }
}
